import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { RenderHTML } from '@shared/ui-components/render-html/render-html';
import { Separator } from '../enums/separator';
import styles from './rich-text-block.module.scss';
type RichTextBlockProps = {
  className?: string;
  heading?: string;
  html: string;
  id?: Nullable<string>;
  noParagraphGutters?: boolean;
  onDark?: boolean;
  separator?: string;
  standalone?: boolean;
};
export const RichTextBlock = t0 => {
  const $ = _c(9);
  const {
    className,
    heading,
    html,
    id,
    noParagraphGutters,
    onDark,
    separator,
    standalone
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== heading || $[2] !== html || $[3] !== id || $[4] !== noParagraphGutters || $[5] !== onDark || $[6] !== separator || $[7] !== standalone) {
    t1 = standalone ? <section className={classnames(styles["standalone-section"], {
      [styles["standalone-section--separator-bottom"]]: separator === Separator.Bottom || separator === Separator.Both,
      [styles["standalone-section--separator-top"]]: separator === Separator.Top || separator === Separator.Both
    })} {...id && {
      id
    }}>{heading && <h2>{heading}</h2>}<RenderHTML className={classnames(styles["html-block"], {
        [styles["html-block--no-paragraph-gutters"]]: noParagraphGutters,
        [styles["html-block--on-dark"]]: onDark,
        [styles["html-block--standalone"]]: standalone
      }, className)} html={html} /></section> : <RenderHTML className={classnames(styles["html-block"], {
      [styles["html-block--no-paragraph-gutters"]]: noParagraphGutters,
      [styles["html-block--on-dark"]]: onDark
    }, className)} html={html} {...id && {
      id
    }} />;
    $[0] = className;
    $[1] = heading;
    $[2] = html;
    $[3] = id;
    $[4] = noParagraphGutters;
    $[5] = onDark;
    $[6] = separator;
    $[7] = standalone;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};